import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'

export const menuAlunoEspecial: UnespCoreMenuItem[] = [
  // ALUNO_ESPECIAL
  {
    displayName: 'Meus Dados',
    iconName: 'person',
    roles: ['ALUNO_ESPECIAL'],
    order: 1,
    children: [
      {
        displayName: 'Atualização Cadastral',
        iconName: 'description',
        roles: ['ALUNO_ESPECIAL'],
        order: 1,
        route: 'discente/meus-dados/dados-cadastrais',
      },
      {
        displayName: 'Horário de Aulas',
        iconName: 'schedule',
        roles: ['ALUNO_ESPECIAL'],
        order: 2,
        route: 'discente/meus-dados/horario-aulas',
      },
      {
        displayName: 'Situação Acadêmica',
        iconName: 'info',
        roles: ['ALUNO_ESPECIAL'],
        order: 3,
        route: 'discente/meus-dados/situacao-academica',
      },
    ],
  },
  {
    displayName: 'Consultas',
    iconName: 'search',
    roles: ['ALUNO_ESPECIAL'],
    order: 2,
    children: [
      {
        displayName: 'Minhas Disciplinas',
        iconName: 'list',
        roles: ['ALUNO_ESPECIAL'],
        order: 1,
        route: 'discente/consulta/minhas-disciplinas',
      },
    ],
  },
  {
    displayName: 'Documentos',
    iconName: 'folder_open',
    roles: ['ALUNO_ESPECIAL'],
    order: 6,
    children: [
      {
        displayName: 'Nova Solicitação',
        iconName: 'add_circle',
        roles: ['ALUNO_ESPECIAL'],
        order: 1,
        route: 'discente/documentos/nova-solicitacao',
      },
      {
        displayName: 'Histórico de Solicitações',
        iconName: 'task',
        roles: ['ALUNO_ESPECIAL'],
        order: 2,
        route: 'discente/documentos/historico-solicitacoes',
      },
    ],
  },
  {
    displayName: 'Mensagens',
    iconName: 'mail',
    roles: ['ALUNO_ESPECIAL'],
    order: 7,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Recebidas',
        iconName: 'mark_email_read',
        roles: ['ALUNO_ESPECIAL'],
        order: 1,
        route: 'discente/mensagens/recebidas',
      },
    ],
  },
  // PUBLICO
  {
    displayName: 'Autenticidade de documento',
    iconName: 'qr_code_scanner',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'autenticidade-documento',
    order: 998,
  },
  // COMUN
  {
    displayName: 'Voltar ao portal',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'voltar-portal',
    order: 1000,
  },
]
